var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorningsnacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2D5D7"
    },
    d: "M56,38.5H2c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-2,2-2h54c1.1,0,2,0.9,2,2v0C58,37.6,57.1,38.5,56,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M2.458,38.5C5.421,43.13,18,48.705,18,55.5h11h11c0-6.795,12.579-12.37,15.542-17H2.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB579"
    },
    d: "M9,32.5c-0.553,0-1-0.447-1-1c0-6.065,4.935-11,11-11h2c0.553,0,1,0.447,1,1s-0.447,1-1,1h-2 c-4.963,0-9,4.037-9,9C10,32.053,9.553,32.5,9,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB579"
    },
    d: "M15,32.5c-0.553,0-1-0.447-1-1c0-2.757,2.243-5,5-5h5c0.553,0,1,0.447,1,1s-0.447,1-1,1h-5 c-1.654,0-3,1.346-3,3C16,32.053,15.553,32.5,15,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD490"
    },
    d: "M12,32.5c-0.553,0-1-0.447-1-1c0-4.411,3.589-8,8-8h4c0.553,0,1,0.447,1,1s-0.447,1-1,1h-4 c-3.309,0-6,2.691-6,6C13,32.053,12.553,32.5,12,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD490"
    },
    d: "M24,31.5h-5c-0.553,0-1-0.447-1-1s0.447-1,1-1h5c0.553,0,1,0.447,1,1S24.553,31.5,24,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD490"
    },
    d: "M48,32.5c-0.553,0-1-0.447-1-1c0-4.963-4.037-9-9-9h-7c-0.553,0-1-0.447-1-1s0.447-1,1-1h7 c6.065,0,11,4.935,11,11C49,32.053,48.553,32.5,48,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD490"
    },
    d: "M42,32.5c-0.553,0-1-0.447-1-1c0-1.654-1.346-3-3-3h-5c-0.553,0-1-0.447-1-1s0.447-1,1-1h5 c2.757,0,5,2.243,5,5C43,32.053,42.553,32.5,42,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB579"
    },
    d: "M45,32.5c-0.553,0-1-0.447-1-1c0-3.309-2.691-6-6-6h-6c-0.553,0-1-0.447-1-1s0.447-1,1-1h6 c4.411,0,8,3.589,8,8C46,32.053,45.553,32.5,45,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB579"
    },
    d: "M38,31.5h-5c-0.553,0-1-0.447-1-1s0.447-1,1-1h5c0.553,0,1,0.447,1,1S38.553,31.5,38,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD490"
    },
    d: "M27,32.5c-0.553,0-1-0.447-1-1c0-8.748-2.617-13-8-13c-0.552,0-1,0.448-1,1c0,0.553-0.447,1-1,1 s-1-0.447-1-1c0-1.654,1.346-3,3-3c4.562,0,10,2.603,10,15C28,32.053,27.553,32.5,27,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB579"
    },
    d: "M30,32.5c-0.553,0-1-0.447-1-1c0-4.811-1.072-16-11-16c-2.757,0-5,2.243-5,5v1c0,0.553-0.447,1-1,1 s-1-0.447-1-1v-1c0-3.859,3.141-7,7-7c8.141,0,13,6.729,13,18C31,32.053,30.553,32.5,30,32.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A46F3E"
    },
    cx: 25.5,
    cy: 9,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A46F3E"
    },
    cx: 43.5,
    cy: 16,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4C312C"
    },
    cx: 33.5,
    cy: 15,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4C312C"
    },
    cx: 39.5,
    cy: 7,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F75B57"
    },
    d: "M41.383,51.5H16.617c0.436,0.654,0.786,1.321,1.023,2h22.719 C40.597,52.821,40.947,52.154,41.383,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M41.383,51.5c0.453-0.68,0.994-1.347,1.606-2H15.011c0.612,0.653,1.153,1.32,1.606,2H41.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88C057"
    },
    d: "M12.912,47.5c0.75,0.653,1.461,1.319,2.1,2h27.977c0.638-0.681,1.35-1.347,2.1-2H12.912z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorningsnacks);
export default __webpack_public_path__ + "static/media/morningsnacks.5e9f36be3733dcce34f55c5b09ccb512.svg";
export { ForwardRef as ReactComponent };